function isAddressQueryLongEnough(query: string) {
  return query.length >= 2
}

export default isAddressQueryLongEnough
